const Loader = () => {
  return (
    <div className="loader-wrapper">
      <img src="/assets/images/spinner.svg" className="loader" alt="loader" />
    </div>
  );
};

export default Loader;
